import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { FreightShipment } from './FreightShipment'

export class FreightShipmentBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => FreightShipment)
  shipment?: FreightShipment

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
